import styled from 'styled-components';

export const StyledUserName = styled.div<{ $isActive: boolean; $isBaymax?: boolean }>`
  position: relative;
  border: 1px solid transparent;
  text-align: center;
  user-select: none;

  &:active {
    border: 1px solid ${({ theme }): string => theme.admanColors!.blue.light.fg[4]};
  }

  .TrekUserIdentifier-avatar {
    font-family: InspireTWDC;
    font-size: 12px;
    font-style: normal;
    font-weight: ${({ $isActive }): string => ($isActive ? '600' : '400')};
    line-height: 18px;
  }

  .TrekUserIdentifier-userName,
  .TrekAccountMenu-iconContainer {
    display: ${({ $isBaymax }): string => ($isBaymax ? 'none' : 'flex')};
    color: ${({ theme, $isActive }): string =>
      $isActive ? theme.colors!.colorWhite : theme.admanColors!.blue.light.fg[4]};
    font-family: InspireTWDC;
    font-size: 16px;
    font-style: normal;
    line-height: 100%;
    text-shadow: ${({ theme, $isActive }): string => ($isActive ? `0 0 1px ${theme.colors!.colorWhite}` : 'none')};
  }

  &:hover {
    .TrekAccountMenu-root {
      background: inherit;
    }

    .TrekUserIdentifier-userName {
      text-shadow: 0 0 1px ${({ theme }): string => theme.colors!.colorWhite};
      color: ${({ theme }): string => theme.colors!.colorWhite};
    }
  }

  .TrekAccountMenu-root {
    border-radius: ${({ theme }): string => theme.spacers!.spacer02};
    background: inherit;
  }

  .TrekAccountMenu-container {
    box-shadow: none;
    padding: ${({ theme: { spacers } }): string => `20px ${spacers!.spacer02} 20px 0`};
    height: 0;
  }

  .TrekUserIdentifier-avatar {
    color: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
    background: ${({ theme }): string => theme.admanColors!.gray.light.fg[6]};
  }

  .TrekAccountMenu-iconContainer {
    path {
      fill: ${({ theme }): string => theme.colors!.colorWhite2};
    }
  }
`;

export const StyledLoaderWrapper = styled.div`
  min-width: 200px;
`;
